module.exports = __webpack_public_path__ + "static/3-c3b1e20717de62fd17b6a39f2b5db6af.jpg";